import { AnalyticsScript, Loading } from '@p2p/components';
import { PaymentTemplate } from '@p2p/entities/templates';
import { useMatchingPaymentNavigation } from '@p2p/pages/MatchingPayment/MatchingPayment.hooks';
import { useGetMerchantOrderQuery, usePageSettings } from '@p2p/services';
import { routes } from '@p2p/shared/routing';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { MatchingPaymentErrorBoundary } from './MatchingPaymentErrorBoundary';

const POLLING_INTERVAL = 2000;

export const MatchingPayment = () => {
  const { id = '' } = useParams<{ id: string }>();
  const {
    isLoading,
    data: order,
    isFetching,
  } = useGetMerchantOrderQuery(id, {
    skip: !id,
    pollingInterval: POLLING_INTERVAL,
  });
  const {
    data: pageSettings,
    isLoading: isLoadingPageSettings,
    isFetching: isFetchingPageSettings,
  } = usePageSettings({ order });

  useMatchingPaymentNavigation(order, pageSettings, isFetching || isFetchingPageSettings);

  if (isLoading || isLoadingPageSettings || !order || !pageSettings) {
    return <Loading />;
  }

  if (order.payment_form !== 'msp_page') {
    return <Navigate to={routes.notFoundError.template} replace />;
  }

  return (
    <MatchingPaymentErrorBoundary>
      <PaymentTemplate>
        <Outlet />
      </PaymentTemplate>
      <AnalyticsScript />
    </MatchingPaymentErrorBoundary>
  );
};
